import { trigger, style, transition, animate, keyframes, query, stagger, group, state, animateChild } from '@angular/animations';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-buttonreason',
  templateUrl: './buttonreason.component.html',
  styleUrls: ['./buttonreason.component.css'],
  animations: [
    trigger('ngIfAnimation', [
      transition('void => *', [
        //query('div', style({ opacity: 0, background: 'blue' }), { optional: true, limit: 1 }),
        query(':self', stagger('300ms', [
          animate('0.8s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: .5, transform: 'translateY(15px)', offset: 0.2 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true, limit: 1 }),
      ]),
      transition('* => void', [
        //query('.wrap-reason', style({ opacity: 1, background: 'red' }), { optional: true }),
        query(':self', stagger('300ms', [
          animate('0.8s ease-in', keyframes([
            style({ opacity: 1, transform: 'translateY(0)', offset: 0 }),
            style({ opacity: .5, transform: 'translateY(15px)', offset: 0.2 }),
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 1.0 }),
          ]))]), { optional: true, limit: 1 }),
      ])
    ])
  ]
})

export class ButtonreasonComponent implements OnInit {
  @Output() onReasonClick: EventEmitter<any> = new EventEmitter();
  @Input() titleList: string;
  @Input() nameButton: string;
  @Input() data: any;
  @Output() dataSelected: any;

  toggleState: boolean;

  constructor() { }

  ngOnInit() {
    //this.titleList = 'Motivo de Anulación';
    //this.nameButton = 'ANULAR CONTRATO';
    //this.data = ['Winter', 'Spring', 'Summer', 'Autumn'];
    this.toggleState = false;
  }

  onClickButton() {
    this.toggleState = true;
  }

  onOk(){
    this.onReasonClick.emit(this.dataSelected);
    this.toggleState = false;
  }

  onCancel(){
    this.toggleState = false;
  }
}
